<template>
  <footer class="footer">
    <div class="container" :class="{'footer-rwd': this.$route.name === 'CourseLesson'}">
      <div class="row py-5">
        <div class="row justify-content-around col-md-8">
          <div  v-if="authorized" class="col-sm-3 col-6">
            <h4>幫助</h4>
            <p class="pointer" @click="$router.push({ name: 'FAQ'})"> FAQ </p>
            <p>
              <a target="_blank" href="./files/Live日本語字帖.pdf">五十音習字帖下載</a>
            </p>
          </div>
          <div class="col-sm-3 col-6">
            <h4>
              相關連結
            </h4>
            <p>
              <a target="_blank" href="https://www.facebook.com/LiveAbc/">FB</a>
            </p>
            <p>
              <a target="_blank" href="https://www.instagram.com/liveabc.official/">IG</a>
            </p>
            <p>
              <a target="_blank" href="https://store.liveabc.com/">官方網站</a>
            </p>
          </div>
          <div class="col-sm-6 mt-3 mt-sm-0">
            <h4>
              客戶服務
            </h4>
            <p>
              一般用戶客服專線: 02-2578-7838
            </p>
            <p>
              企業用戶客服專線: 02-2578-2626#219
            </p>
            <p>
              客服時間: 週一至週五 09:00~18:00
            </p>
            <p>
              客服信箱: livejapanese@liveabc.com
            </p>
            <p>
              Copyright©Hebron Soft Limited. All Rights Reserved.
            </p>
          </div>
        </div>
        <div class="footer-title col-md-4">
          <h2>Live 日本語</h2>
          <div style="height:180px;">
            <img style="width:150px" src="../assets/QRcode.png" alt="">
          </div>
          <!-- <select v-model="locale" @change="setLocale(locale)">
            <option value="en">English</option>
            <option value="tw">繁體中文</option>
            <option value="cn">简体中文</option>
          </select> -->
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Footer',
  data () {
    return {
      locale: window.localStorage.getItem('locale') || 'tw'
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters([
      'authorized'
    ])
  },
  methods: {
    setLocale (locale) {
      window.localStorage.setItem('locale', locale || 'tw')
      this.locale = locale
      this.$store.commit("setLocal")
      this.scrollTop()
      return window.history.go(0)
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/color.scss";
@import "../assets/styles/custom.scss";
  .footer {
    background-color: #c95867;
    min-height: 150px;
    color: $white-color;
    position: relative;
    .footer{
      text-align: left;
    }
    h4 {
      text-align: left;
      font-weight: bolder;
    }
    p {
      text-align: left;
    }
    .footer-title {
      h3 {
        @include text(5rem, .2rem, white);
      }
    }
  }
  a,a:hover {
    color: #fff;
  }
  @media screen and (max-width: 600px) {
    .footer-rwd {
      display: none;
    }
  }
</style>
